import validator from "validator";

const validateDescription = (value: string) => {
  if (validator.isEmpty(value)) {
    return {
      isValid: false,
      message: "Ce champ est requis",
    };
  } else if (value.length < 60 || value.length > 1000) {
    return {
      isValid: false,
      message: "La description doit contenir entre 60 et 1000 caractères",
    };
  } else {
    return {
      isValid: true,
      message: "",
    };
  }
};

export default validateDescription;
